import { FLOW_CREDITS_PURCHASE_MODAL_RECEIVE } from '../constants';

export const receive = (flowCreditPurchaseModal) => ({
    type: FLOW_CREDITS_PURCHASE_MODAL_RECEIVE,
    payload: flowCreditPurchaseModal,
});